import { useMemo } from 'react';

export default function Donut({ segments = [], size = 96, thickness = 12, centerText = '' }) {
  const gradient = useMemo(() => {
    let acc = 0;
    const parts = segments.map(({ value, color }) => {
      const from = acc;
      const to = acc + value;
      acc = to;
      return `${color} ${from}% ${to}%`;
    });
    if (acc < 100) parts.push(`#e5e7eb ${acc}% 100%`);
    return `conic-gradient(${parts.join(',')})`;
  }, [segments]);
  return (
    <div className="inline-flex relative" style={{ width: size, height: size }}>
      <div className="rounded-full" style={{ width: size, height: size, backgroundImage: gradient }} />
      <div className="grid absolute inset-0 place-items-center">
        <div className="bg-white rounded-full" style={{ width: size - thickness * 2, height: size - thickness * 2 }} />
      </div>
      <div className="grid absolute inset-0 place-items-center">
        <span className="text-xs font-semibold text-gray-700">{centerText}</span>
      </div>
    </div>
  );
}


